/**
 * Preview-mode session stub. Returns a fixed session so every auth-protected
 * page renders without better-auth touching the DB.
 *
 * Shape matches better-auth's Session.Infer output — if better-auth upgrades
 * and the shape shifts, update this.
 */
import { fixtures } from "./fixtures";

export const previewSession = {
  session: fixtures.session,
  user: fixtures.user,
} as const;

export type PreviewSession = typeof previewSession;
